import { REFERRER_ALLOWED_HOSTS } from 'lib/constants/referrerAllowlist';
import NextLink from 'next/link';

/**
 * Whether an external destination is on the referrer allowlist. For these hosts
 * we keep `noopener` for security but drop `noreferrer`, so the destination
 * receives the `Referer` header and can attribute incoming traffic. Matches
 * each allowlisted host exactly (which may itself be a subdomain) plus any of
 * its subdomains. Returns `false` for missing/relative/malformed hrefs.
 */
export const shouldSendReferrer = (href?: string): boolean => {
  if (!href) return false;
  try {
    const { hostname } = new URL(href);
    return REFERRER_ALLOWED_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`),
    );
  } catch {
    return false;
  }
};

export const getExternalLinkProps = (isExternal?: boolean, href?: string) =>
  isExternal
    ? ({
        as: 'a',
        target: '_blank',
        rel: shouldSendReferrer(href) ? 'noopener' : 'noopener noreferrer',
      } as const)
    : ({ as: NextLink } as const);

export const getShowIconProps = (showIcon?: boolean) =>
  showIcon ? ({ afterIconName: 'ArrowUpRight' } as const) : {};
